import { Component, Host, State, h } from '@stencil/core';
import { Logo } from './components/Logo';
import { Menu } from './components/Menu';
import { Search } from './components/Search';
import { IntDropdown } from './components/IntDropdown';

@Component({
  tag: 'cradlepoint-nav',
  styleUrl: 'cradlepoint-nav.scss',
  shadow: false,
})

export class CradlepointNav {
  @State() openMenuName: string | null = null;
  @State() accountMenuOpen: boolean = false;
  @State() countries: { name: string, url: string }[] = [
    { name: "United Kingdom (UK)", url: "/gb" },
    { name: "France (FR)", url: "/fr" },
    { name: "Germany (DE)", url: "/de" },
  ];

  private handleClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;

    if (target.closest('button.menu-close')) {
      this.openMenuName = null;
      event.stopPropagation();
      return;
    }

    if (target.tagName.toLowerCase() === 'button') {
      const parentLi = target.closest('li.e-main-menu__item');
      if (parentLi) {
        const menuName = parentLi.getAttribute('data-tabular');
        if (menuName) {
          // Check if the current menu is already open and not using sub-menu navigation
          if (this.openMenuName === menuName && !target.className.includes('e-sub-menu__next')) {
            this.openMenuName = null;
          } else {
            this.openMenuName = menuName;
          }
        }
      }
    }
  };

  private handleDocumentClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;

    // Close menu if clicked outside menu components
    if (!target.closest('li.e-main-menu__item') && !target.closest('button.menu-close')) {
      this.openMenuName = null;
    }
  };

  async componentDidLoad() {
    const handleClick = this.handleClick;
    document.addEventListener('click', handleClick);
    document.addEventListener('click', this.handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleClick);
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('click', handleClick);
    };
  }

  render() {
    return (
      <Host>
        <div id="eTopNavigation" class="e-header">
          <div class="e-header__row" role="menubar">
            <Logo />
            <div class="e-header__center">
              <Menu openMenuName={this.openMenuName} />
              <Search />
            </div>
            <IntDropdown countries={this.countries}/>
            <button id="eHeader-MenuToggle" class="e-header__toggle" title="Open menu"></button>
          </div>
          <div class={`e-header__backdrop ${!!this.openMenuName && "show"}`}></div>
        </div>
      </Host>
    );
  }
}